// extracted by mini-css-extract-plugin
export default {"mobileMode":"35.625em","tabsContainer":"tabsContainer__1vuhu","tabs":"tabs__3I5Me","tabsItem":"tabsItem__2jyJs","tabsItemLink":"tabsItemLink__1KS_2","active":"active__cm5HO"};
    if(module.hot) {
      // 1778491680026
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  